<div class="user-menu d-flex justify-content-center item-align-center me-2">
  @if (!!userDisplayName) {
    <div ngbDropdown class="d-inline-block">
      <button
        type="button"
        class="btn p-0 border-0 bg-transparent avatar-toggle d-flex align-items-center"
        id="dropdownBasic1"
        ngbDropdownToggle
        [title]="userDisplayName"
      >
        <span class="me-2 text-white">{{ userDisplayName }}</span>
        <adf-avatar [name]="userDisplayName" [email]="userEmail" [size]="28" [self]="true" />
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <!-- Hidden until user settings exist; keep the item so it can be switched on without rebuilding it. -->
        @if (showSettings) {
          <button ngbDropdownItem (click)="onSettings()">
            {{ 'Settings' | translate }}
          </button>
        }
        <button ngbDropdownItem (click)="onLogout()">{{ 'Logout' | translate }}</button>
        <div class="dropdown-divider"></div>
        <div class="app-version px-3 py-1 small text-body-secondary user-select-all" title="Application version">
          PreCalc {{ appVersion }}
        </div>
      </div>
    </div>
  } @else {
    {{ 'Log in' }}
  }
</div>
